
<v-content>
  <v-row class="layout" wrap>
    <v-col cols="12">
      <h1 class="display-1">
        {{ $t("IMPRINT_HEADER") }}
      </h1>
    </v-col>
    <v-col class="imprintContent" cols="12">
      <div v-html="$t('IMPRINT_TEXT')"></div>
    </v-col>
  </v-row>
</v-content>

